export default __webpack_public_path__ + "static/uCall x Giao Duc_page-0001-44ee932c7471fb960a38b1481e4b4512.jpg";